<template>
  <div class="w-full">
    <b-form-group
      id="input-group-6-label"
      label-for="select-product"
      label-class="w-full mb-0"
    >
      <template #label>
        <div class="flex justify-between items-center h-6 mb-1">
          <span class="font-medium text-[#333333]">Nama Produk<span class="text-danger">*</span></span>
        </div>
      </template>
      <v-select
        id="select-product"
        v-model="selectedProductsData"
        name="product_ids"
        placeholder="Pilih atau cari nama produk"
        required
        label="product_name"
        multiple
        :options="listProducts"
        class="custom-product-select"
        :filterable="false"
        :selectable="(option) => selectedProductsData.length < 5 "
        @input="$emit('update:address_id', $event)"
        @open="onProductDropdownOpen"
        @close="onProductDropdownClose"
        @search="onProductSearch"
      >
        <template #search="{ attributes, events }">
          <div class="flex items-center gap-2 w-full">
            <div
              v-if="selectedProductsData.length > 0 && !isProductSelectOpen"
              class="px-2 text-[#333333] whitespace-nowrap"
            >
              {{ selectedProductsData.length }} Produk Terpilih
            </div>
            <input
              class="vs__search pl-2 text-gray-700"
              style="width: 100%;"
              v-bind="attributes"
              v-on="events"
            >
          </div>
        </template>
        <template #list-header>
          <li class="sticky top-0 z-10 bg-gray-100 border-b">
            <div class="flex flex-col sm:flex-row items-center p-2.5 py-2 font-medium text-gray-600">
              <div class="w-full sm:w-5/12">
                Produk
              </div>
              <div class="w-full sm:w-3/12 text-center sm:text-left">
                Variasi
              </div>
              <div class="w-full sm:w-3/12 text-center sm:text-left">
                Harga
              </div>
              <div class="w-full sm:w-2/12 text-center">
                Stok
              </div>
            </div>
          </li>
        </template>
        <template #list-footer>
          <div
            v-if="isLoadingProducts"
            class="text-center text-gray-500 p-3"
          >
            <b-spinner
              small
              variant="primary"
            />
            <span class="ml-2">Memuat produk...</span>
          </div>
          <div
            v-else-if="!hasMoreProducts && listProducts && listProducts.length > 0"
            class="text-center text-gray-400 p-3 text-sm"
          >
            <b-icon icon="check-circle" />
            <span class="ml-2">Semua produk sudah ditampilkan</span>
          </div>
        </template>
        <template #no-options>
          <div class="flex my-1 justify-center">
            <div class="border w-fit rounded-md p-[8px]">
              <b-img
                width="30"
                height="30"
                center
                src="https://storage.googleapis.com/komerce/assets/icons/search-abu.svg"
              />
            </div>
          </div>
          <div class="text-[#333333]">
            Tidak ada produk tersedia
          </div>
          <div class=" mb-2 text-[#828282]">
            Tambahkan produk kamu
          </div>
        </template>

        <template #option="data">
          <div>
            <div
              class="flex flex-col sm:flex-row items-center sm:items-center p-2.5 py-2"
            >
              <div class="flex items-center gap-3 w-full sm:w-5/12  sm:mb-0">
                <b-img
                  :src="data.product_image ? data.product_image : 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'"
                  alt="Product Image"
                  class="w-10 h-10 object-cover rounded flex-shrink-0"
                />
                <div class="flex-grow min-w-0">
                  <div
                    class="font-medium  leading-snug truncate"
                    :title="data.product_name"
                  >
                    {{ data.product_name }}
                  </div>
                  <div
                    class=" leading-snug truncate"
                    :title="data.product_sku"
                  >
                    SKU: {{ data.product_sku }}
                  </div>
                </div>
              </div>
              <div
                class="w-full sm:w-3/12    sm:mb-0 text-center sm:text-left truncate"
                :title="data.has_variant ? `${data.variants.length} Variasi` : '-'"
              >
                {{ data.has_variant ? `${data.variants.length} Variasi` : '-' }}
              </div>
              <div class="w-full sm:w-3/12    sm:mb-0 text-center sm:text-left ">
                {{ data.product_price | currency }}
              </div>
              <div class="w-full sm:w-2/12    sm:mb-0 text-center">
                {{ data.product_stock }}
              </div>
            </div>
          </div>
        </template>
      </v-select>
    </b-form-group>
    <div
      v-if="isResolvingSelectedProducts"
      class="flex items-center gap-2 my-2 text-[#828282] text-sm"
    >
      <b-spinner
        small
        variant="primary"
      />
      <span>Memuat produk terpilih...</span>
    </div>
    <!-- <div class="grid my-2 grid-cols-1 lg:grid-cols-3 gap-3">
      <div
        v-for="(item, index) in computedSelectedProducts"
        :key="index"
        class="rounded-lg p-[3px] border"
        :class="getProductPriceAfterDiscount(item) < 10000 ? 'bg-red-50 border-red-300' : 'bg-[#F4F4F4]'"
      >
        <div class="flex justify-between items-center gap-2">
          <div class="flex items-center gap-2">
            <b-img
              class="w-14"
              rounded
              :src="(item.product_image || item.url) ? (item.product_image || item.url) : 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'"
            />
            <div class="grid gap-2">
              <div class="font-medium  leading-none tracking-normal text-[#333333]">
                {{ (item.product_name || item.name) && (item.product_name || item.name).length > 15 ? (item.product_name || item.name).slice(0, 15) + '...' : (item.product_name || item.name) || '-' }}
              </div>
              <div class=" font-normal  leading-none tracking-normal text-[#828282]">
                SKU: {{ item.product_sku || '-' }}
              </div>
            </div>
          </div>
          <a @click="onUnselect(item.id || item.product_id)">
            <b-icon icon="x" />
          </a>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import VSelect from 'vue-select'
import { apiGetProductListV4 } from '../service/api.product.service'

export default {
  components: {
    VSelect,
  },
  filters: {
    currency(value) {
      if (value === null || value === undefined) return '-'
      const numValue = Number(value)
      if (Number.isNaN(numValue)) return '-'
      return `Rp${numValue.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')}`
    },
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchKeyword: '',
      searchDebounceTimer: null,
      isProductSelectOpen: false,
      selectedProductsData: [],
      isOnSelectProduct: false,
      productPage: 0,
      productLimit: 15,
      isLoadingProducts: false,
      hasMoreProducts: true,
      scrollDebounceTimer: null,
      localProductList: [],
      isResolvingSelectedProducts: false,
      fetchMissingProductsTimer: null,
      resolveSelectedProductsRunning: false,
    }
  },
  computed: {
    listProducts() {
      return this.localProductList || []
    },
    computedSelectedProducts() {
      return this.selectedProductsData
    },
    hasInvalidProductPrice() {
      const selectedProducts = this.computedSelectedProducts
      if (!selectedProducts || selectedProducts.length === 0) return false

      return selectedProducts.some(product => {
        const originalPrice = Number(product.product_price || product.price) || 0
        if (originalPrice < 10000) return true

        const productDiscountPercent = Number(this.formData.product_discount) || 0
        const productDiscountAmount = (originalPrice * productDiscountPercent) / 100
        const priceAfterProductDiscount = originalPrice - productDiscountAmount

        const paymentDiscountPercent = Number(this.formData.payment_discount) || 0
        const paymentDiscountAmount = (priceAfterProductDiscount * paymentDiscountPercent) / 100
        const finalPrice = priceAfterProductDiscount - paymentDiscountAmount

        return finalPrice < 10000
      })
    },
    computedInvalidPriceProducts() {
      const selectedProducts = this.computedSelectedProducts
      if (!selectedProducts || selectedProducts.length === 0) return []

      return selectedProducts.filter(product => {
        const originalPrice = Number(product.product_price || product.price) || 0
        if (originalPrice < 10000) return true
        return this.getProductPriceAfterDiscount(product) < 10000
      }).map(product => product.product_name || product.name)
    },
  },
  watch: {
    selectedProductsData: {
      handler(newVal) {
        this.formData.product_ids = newVal.map(item => item.id)
        this.$emit('validate')
        this.$emit('update-selected-products', newVal)
      },
      deep: true,
    },
    isOnSelectProduct(isOpen) {
      if (isOpen) {
        document.addEventListener('mousedown', this.handleClickOutside)
      } else {
        document.removeEventListener('mousedown', this.handleClickOutside)
      }
    },
    'formData.product_ids': {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.isEditMode && newVal && newVal.length > 0) {
          if (this.formData.products && this.formData.products.length > 0 && this.selectedProductsData.length === 0) {
            this.selectedProductsData = [...this.formData.products]
          } else {
            this.scheduleFetchMissingSelectedProducts()
          }
        }

        if (!newVal || newVal.length === 0) {
          if (this.selectedProductsData.length > 0) {
            this.selectedProductsData = []
          }
        } else if (this.selectedProductsData.length > 0) {
          const currentIds = new Set(newVal)
          const filtered = this.selectedProductsData.filter(p => currentIds.has(p.id))
          if (filtered.length !== this.selectedProductsData.length) {
            this.selectedProductsData = filtered
          }
        }
      },
    },
    localProductList: {
      handler() {
        if (this.isEditMode && this.formData.product_ids?.length > 0) {
          this.mergeSelectedProductsFromLocalList()
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleClickOutside)
    if (this.scrollDebounceTimer) {
      clearTimeout(this.scrollDebounceTimer)
    }
    if (this.fetchMissingProductsTimer) {
      clearTimeout(this.fetchMissingProductsTimer)
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect()
    }
  },
  async mounted() {
    await this.loadProducts()
    await this.fetchMissingSelectedProducts()
  },
  methods: {
    normalizeVariant(variant, productId, fallbackImage) {
      return {
        ...variant,
        id: variant.variant_id || variant.product_variant_id || variant.option_id || `${productId}-${variant.variant || 'variant'}`,
        variant_id: variant.variant_id || variant.product_variant_id || variant.option_id || null,
        product_id: productId,
        product_name: variant.variant || '-',
        product_image: variant.variant_thumbnail_image || fallbackImage,
        product_price: Number(variant.price) || 0,
        product_stock: Number(variant.stock) || 0,
      }
    },
    normalizeProduct(product) {
      const image = product?.product_image?.[0]?.images_path || 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'
      const variants = Array.isArray(product?.variants)
        ? product.variants.map(variant => this.normalizeVariant(variant, product.product_id, image))
        : []
      const hasVariant = variants.length > 0
      const minVariantPrice = hasVariant ? Math.min(...variants.map(item => Number(item.product_price) || 0)) : 0
      const maxVariantPrice = hasVariant ? Math.max(...variants.map(item => Number(item.product_price) || 0)) : 0
      const stockFromVariants = hasVariant ? variants.reduce((sum, item) => sum + (Number(item.product_stock) || 0), 0) : 0

      return {
        id: product.product_id,
        product_id: product.product_id,
        product_name: product.product_name,
        product_image: image,
        product_price: hasVariant ? minVariantPrice : (Number(product.price) || 0),
        product_sku: product.sku || '-',
        product_stock: hasVariant ? stockFromVariants : (Number(product.stock) || 0),
        has_variant: hasVariant,
        min_variant_price: minVariantPrice,
        max_variant_price: maxVariantPrice,
        variants,
      }
    },
    scheduleFetchMissingSelectedProducts() {
      if (this.fetchMissingProductsTimer) {
        clearTimeout(this.fetchMissingProductsTimer)
      }
      this.fetchMissingProductsTimer = setTimeout(() => {
        this.fetchMissingProductsTimer = null
        this.fetchMissingSelectedProducts()
      }, 200)
    },
    async waitForProductListRequestIdle() {
      let waits = 0
      while (this.isLoadingProducts && waits < 250) {
        waits += 1
        // eslint-disable-next-line no-await-in-loop
        await new Promise(resolve => setTimeout(resolve, 20))
      }
    },
    mergeSelectedProductsFromLocalList() {
      const ids = this.formData.product_ids || []
      if (!ids.length) return

      const fromList = new Map(this.localProductList.map(p => [String(p.id), p]))
      const previous = new Map(this.selectedProductsData.map(p => [String(p.id), p]))

      const newSelected = ids
        .map(id => {
          const strId = String(id)
          const fetched = fromList.get(strId)
          const prev = previous.get(strId)
          if (!fetched) return prev
          if (!prev) return fetched

          // Merge discount and checked state from prev into fetched
          const merged = { ...fetched }
          merged.checked = prev.checked
          merged.discount = prev.discount
          merged.minTransaction = prev.minTransaction

          if (merged.has_variant && prev.variants) {
            const prevVarMap = new Map(prev.variants.map(pv => [String(pv.variant_id), pv]))
            merged.variants = merged.variants.map(v => {
              const prevVar = prevVarMap.get(String(v.variant_id))
              if (prevVar) {
                return {
                  ...v,
                  checked: prevVar.checked,
                  discount: prevVar.discount,
                  minTransaction: prevVar.minTransaction,
                }
              }
              return v
            })
          }
          return merged
        })
        .filter(Boolean)

      // Only reassign if the array length or references changed to prevent vue reactivity loops
      if (
        this.selectedProductsData.length !== newSelected.length
        || this.selectedProductsData.some((item, index) => item !== newSelected[index])
      ) {
        this.selectedProductsData = newSelected
      }
    },
    async fetchMissingSelectedProducts() {
      if (!this.isEditMode || !this.formData.product_ids?.length) return
      if (this.resolveSelectedProductsRunning) return

      const targetIds = this.formData.product_ids
      const isMissing = () => targetIds.some(
        id => !this.localProductList.some(p => String(p.id) === String(id)),
      )

      this.resolveSelectedProductsRunning = true
      this.isResolvingSelectedProducts = true
      try {
        await this.waitForProductListRequestIdle()
        this.mergeSelectedProductsFromLocalList()

        let loops = 0
        while (isMissing() && this.hasMoreProducts && loops < 10) {
          loops += 1
          // eslint-disable-next-line no-await-in-loop
          await this.loadProducts(false)
          // eslint-disable-next-line no-await-in-loop
          await this.waitForProductListRequestIdle()
          this.mergeSelectedProductsFromLocalList()
        }
      } finally {
        this.isResolvingSelectedProducts = false
        this.resolveSelectedProductsRunning = false
      }
    },
    onUnselect(id) {
      this.selectedProductsData = this.selectedProductsData.filter(product => (product.id || product.product_id) !== id)
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.productDropdownContainer
      if (dropdown && !dropdown.contains(event.target)) {
        const triggerButton = document.getElementById('input-group-6-trigger')
        if (triggerButton && !triggerButton.contains(event.target)) {
          this.isOnSelectProduct = false
        }
      }
    },
    async loadProducts(reset = false) {
      if (this.isLoadingProducts || (!this.hasMoreProducts && !reset)) {
        return
      }
      try {
        this.isLoadingProducts = true
        if (reset) {
          this.hasMoreProducts = true
          this.localProductList = []
        }
        const offset = this.localProductList.length
        const { data } = await apiGetProductListV4({
          keyword: this.searchKeyword,
          offset,
          limit: this.productLimit,
        })
        const products = (data?.data || []).map(this.normalizeProduct)
        if (reset) {
          this.localProductList = products
        } else {
          const newProducts = products.filter(p => !this.localProductList.some(lp => lp.id === p.id))
          this.localProductList = [...this.localProductList, ...newProducts]
          if (newProducts.length === 0 && products.length > 0) {
            this.hasMoreProducts = false
          }
        }
        if (products.length < this.productLimit) {
          this.hasMoreProducts = false
        }
      } catch (error) {
        console.error('Error loading products:', error)
        this.$toast_error({ message: error.message || 'Gagal memuat produk' })
        this.hasMoreProducts = false
      } finally {
        this.isLoadingProducts = false
      }
    },
    handleProductScroll(event) {
      if (this.scrollDebounceTimer) {
        clearTimeout(this.scrollDebounceTimer)
      }
      this.scrollDebounceTimer = setTimeout(() => {
        const { scrollTop, scrollHeight, clientHeight } = event.target || event
        const threshold = 100
        const distanceFromBottom = scrollHeight - scrollTop - clientHeight

        if (distanceFromBottom < threshold && !this.isLoadingProducts && this.hasMoreProducts) {
          this.loadProducts()
        }
      }, 150)
    },
    onProductSearch(search, loading) {
      this.searchKeyword = search
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer)
      }
      this.searchDebounceTimer = setTimeout(() => {
        this.loadProducts(true)
      }, 500)
    },
    onProductDropdownOpen() {
      this.isProductSelectOpen = true
      this.$nextTick(() => {
        const dropdown = this.$el.querySelector('.vs__dropdown-menu')
        if (dropdown) {
          dropdown.addEventListener('scroll', this.handleProductScroll)
        }
        const searchInput = this.$el.querySelector('.vs__search')
        if (searchInput) {
          searchInput.focus()
        }
      })
    },
    onProductDropdownClose() {
      this.isProductSelectOpen = false
      const dropdown = this.$el.querySelector('.vs__dropdown-menu')
      if (dropdown) {
        dropdown.removeEventListener('scroll', this.handleProductScroll)
      }
    },
    getProductPriceAfterDiscount(product) {
      const originalPrice = Number(product.product_price || product.price) || 0
      const productDiscountPercent = Number(this.formData.product_discount) || 0
      const productDiscountAmount = (originalPrice * productDiscountPercent) / 100
      const priceAfterProductDiscount = originalPrice - productDiscountAmount
      const paymentDiscountPercent = Number(this.formData.payment_discount) || 0
      const paymentDiscountAmount = (priceAfterProductDiscount * paymentDiscountPercent) / 100
      const finalPrice = priceAfterProductDiscount - paymentDiscountAmount
      return Math.round(finalPrice)
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

.custom-product-select {
  .vs__dropdown-toggle {
    min-height: 40px !important;
    border-radius: 8px !important;
    border: 1px solid #E2E8F0 !important;
    padding: 0 0.5rem !important;
    align-items: center;
  }

  .vs__selected {
    display: none !important;
  }

  .vs__search {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 0.875rem !important;
    color: #1E293B !important;

    &::placeholder {
      color: #94A3B8 !important;
    }
  }

  &.vs--open .vs__dropdown-toggle {
    border-color: #F97316 !important;
    box-shadow: 0 0 0 1px rgba(249, 115, 22, 0.2) !important;
  }
}
</style>
